<template>
  <div>
    <LmTreeSelect
      class="w-100 mb-3"
      placeholder="Tipo de documento"
      path-to-get-async-options="/documenttypes/predictive"
      async
      v-model="picked"
      @input="onPickDocument"
    />
    <div>
      <span class="mr-3">En Estado</span>
      <lm-dropdown
        class="d-inline-block"
        :data-items="statusOptions"
        closeAfterPick
        hideSearchInput
        @input="onPickStatus"
      >
        <span class="text-primary">
          {{ status.name }}
        </span>
      </lm-dropdown>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import commonsApi from '@/api/commons'
import LmDropdown from '@/components/LmDropdown'
import LmTreeSelect from '@/components/form/elements/LmTreeSelect'

export default defineComponent({
  components: {
    LmDropdown,
    LmTreeSelect
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    isLoading: false,
    options: [],
    statusOptions: [
      { id: 'any', name: 'Cualquiera' }
    ],
    picked: null,
    status: { id: 'any', name: 'Cualquiera' }
  }),
  methods: {
    getPopupContainer () {
      return this.$el
    },
    onPickDocument (item) {
      Object.assign(this.picked, item)
      this.picked.status = this.status
      this.$emit('change', this.picked)
    },
    onPickStatus (event) {
      this.status = event
      this.picked.status = this.status
      this.$emit('change', this.picked)
    }
  },
  watch: {
    value: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val && Object.keys(val).length) {
          this.status = val.status
          this.picked = val
        }
      }
    }
  },
  async created () {
    const response = await commonsApi.axiosGetWrapper('/documents/status')
    this.statusOptions = [].concat(this.statusOptions, response.data.items).map(el => {
      return { id: el.id, name: el.name }
    })
  }
})
</script>
